enum EFieldName {
  ObjectCost = 'objectCost',
  DownPayment = 'downPayment',
  loanTermYears = 'loanTermYears',
  benefitProgram = 'benefitProgram',
}

enum EAnalyticsFieldName {
  ObjectCost = 'objectCost',
  DownPayment = 'downPayment',
  LoanTermYears = 'loanTermYears',
  BenefitProgram = 'programType',
}

enum ETestIds {
  CalculatorLayout = 'calculator-layout',
  Form = 'form',
  OfferCard = 'offer-card',
  MainButton = 'main-button',
  ShowOffersButton = 'show-offers-button',
  BankModal = 'bank-modal',
  BuilderModal = 'builder-modal',
  ShowPhoneButton = 'show-phone-button',
  PhoneLink = 'phone-link',
  BankButton = 'bank-button',
  DesktopListing = 'desktop-listing',
  MobileListing = 'mobile-listing',
  PskTooltip = 'psk-tooltip',
  OffersEmpty = 'offers-empty',
  SomethingWentWrong = 'something-went-wrong',
  MobileListingReturnButton = 'mobile-listing-return-button',
  MobileCtaButton = 'mobile-cta-button',
  MobileSummaryContainer = 'mobile-summary-container',
  NewbuildingSeoLink = 'newbuilding-mortgage-link',
}

enum EAuthAnalyticsEvents {
  /* На экране появился попап с окном ввода номера телефона */
  PhoneScreenShown = 'phoneScreenShown',
  /* Клик на подтверждение номера телефона */
  PhoneScreenConfirm = 'phoneScreenConfirm',
  /* На экране появился попап с окном ввода кода из СМС */
  CodeScreenShown = 'codeScreenShown',
  /* Клик на подтверждение кода из СМС */
  CodeScreenConfirm = 'codeScreenConfirm',
  /* Клик на прислать новый СМС-код */
  CodeScreenResend = 'codeScreenResend',
  /* При успешной авторизации дано согласие на рекламу */
  AdvertisingConsent = 'advertisingConsent',
  /* Успешная авторизация */
  AuthSuccess = 'authSuccess',
}

export { EAnalyticsFieldName, EAuthAnalyticsEvents, EFieldName, ETestIds };
